export const comCopy = {
  com_layout_title: "Como configurar TypeScript",
  com_layout_description:
    "Conecte-se com outros do mundo TypeScript online e offline.",
  com_headline: "Conecte-se com a gente",
  com_connect_online: "Online",
  com_connect_online_description:
    "Conte-nos o que está funcionando bem, o que quer ver adicionado ou aprimorado e descubra novas atualizações.",
  com_online_stack_overflow_desc:
    "Conecte-se com colegas e faça perguntas sobre TypeScript usando a tag 'typescript'",
  com_online_stack_overflow_tag: "",
  com_online_discord_header: "Chat",
  com_online_discord_desc:
    "Converse com outros usuários de TypeScript no chat da comunidade TypeScript.",
  com_online_github_desc:
    "Encontrou um bug, ou quer nos dar feedback construtivo?",
  com_online_github_href: "Conte-nos no Github",
  com_online_twitter_desc: "Mantenha-se atualizado. Nos siga no Twitter",
  com_online_blog_desc:
    "Aprenda sobre os desenvolvimentos mais recentes do TypeScript no nosso", //... blog
  com_online_typed_desc: "Definições de tipos de TypeScript.",
  com_online_typed_href: "Navegue pelas milhares de",
  com_online_typed_available_for: "bibliotecas e frameworks disponíveis.",
  com_person: "Conecte-se pessoalmente",
  com_conferences: "Conferências",
  com_conferences_alt_img: "logo de ",
}
